import React from "react";
import { Button as UI5Button } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

export function Button({
  className,
  design = "Default",
  children,
  disabled = false,
  icon,
  iconEnd = false,
  onClick,
  ...props
}) {
  const wrappedChildren = children ? (
    <span className="inline-flex items-center justify-center gap-2">
      {children}
    </span>
  ) : null;

  return (
    <UI5Button
      design={design}
      disabled={disabled}
      icon={icon}
      iconEnd={iconEnd}
      onClick={onClick}
      className={cn(className)}
      {...props}
    >
      {wrappedChildren}
    </UI5Button>
  );
}

/**
 * Button design variants:
 * - 'Default': Standard button
 * - 'Emphasized': Primary action button (blue)
 * - 'Positive': Success button (green)
 * - 'Negative': Destructive button (red)
 * - 'Transparent': Transparent button
 * - 'Attention': Warning button (orange)
 */
